"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localMessage_1 = require("../candidConverters/localMessage");
const CanisterClientFactory_1 = __importDefault(require("../CanisterClientFactory"));
function default_1(searchTerm, maxResults) {
    return __awaiter(this, void 0, void 0, function* () {
        const client = CanisterClientFactory_1.default.current.chatsClient;
        const response = yield client.search_all_messages(searchTerm, maxResults);
        if ("Success" in response) {
            const success = response.Success;
            return {
                kind: "success",
                result: {
                    matches: success.matches.map((m) => ({
                        chatId: m.chat_id,
                        message: localMessage_1.fromCandid(m.message)
                    }))
                }
            };
        }
        else {
            throw new Error("Unrecognised 'search_all_messages' response");
        }
    });
}
exports.default = default_1;
